import * as yup from 'yup';
import {formData} from './LeadGenerationForm.type';
import {isValidPhoneNumber} from '@utils/validation.utils';
import {getCountryCodeAndNameFromValue} from '@services/properties/getLeadGenerationOptions';

export const FORM_DATA_INITIAL_VALUES: formData = {
  firstName: '',
  lastName: '',
  countryCode: '+971___United Arab Emirates',
  contact: '',
  email: '',
  country: 'United Arab Emirates',
  city: '',
  nationality: '',
  language: '',
  goldenVisa: false,
  consent: false,
  otherPropertyUpdates: false,
  aldarUpdates:false
};

export const validationSchema = yup
  .object({
    firstName: yup
      .string()
      .required('First name is required')
      .max(35, 'First name should be 35 characters long')
      .matches(
        /^[A-Za-z\s]+$/,
        'First name should contain only letters and spaces'
      ),
    lastName: yup
      .string()
      .required('Last name is required')
      .max(35, 'Last name should be 35 characters long')
      .matches(
        /^[A-Za-z\s]+$/,
        'Last name should contain only letters and spaces'
      ),
    countryCode: yup.string().required('Country code is required'),
    contact: yup
      .string()
      .required('Phone number is required')
      .test(
        'Phone Number Validity Check',
        'Not a valid phone number',
        function (number) {
          const {code} = getCountryCodeAndNameFromValue(
            this.parent.countryCode
          );
          return isValidPhoneNumber(number, code);
        }
      ),
    email: yup
      .string()
      .required('Email is required')
      .email('Invalid email format'),
    country: yup.string().required('Country of residence is required'),
    city: yup
      .string()
      .ensure()
      .when('country', (country, schema) => {
        return country[0] === 'United Arab Emirates'
          ? schema.required('City is required')
          : schema;
      }),
    nationality: yup.string().required('Nationality is required'),
    language: yup.string().required('Language is required'),
    goldenVisa: yup.boolean().required(),
    consent: yup.boolean().required(),
    otherPropertyUpdates: yup.boolean().required(),
    aldarUpdates: yup.boolean().required(),
  })
  .required();

export const DATE_TIME_FORMATE = 'yyy-MM-dd hh:mm:ss';
export const LEAD_GENERATION_FORM_TYPE = {
  community: 2,
  property: 1,
};

export const MENU_ITEM_PROPS_FOR_PREFERED_LANGUAGES = {
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'center',
  },
  transformOrigin: {
    vertical: 'bottom',
    horizontal: 'center',
  },
  style: {marginTop: '-15px'},
};
